export function YoutubeEmbed({ youtubeUrl, ...props }: { youtubeUrl: string } & React.HTMLAttributes<HTMLIFrameElement>) {
    return <iframe src={youtubeUrl}
        className="rounded-2xl aspect-video w-full"
        width="100%"
        height="352"
        frameBorder={0}
        allowFullScreen={true}
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
        {...props}
    />
}